<template>
    <div class="d-flex flex-column">
        <main-header></main-header>
        <router-view></router-view>
        <v-footer padless app class="footer-height">
            <div class="feuchter-bar"> <span @click="reloadServiceWorker"> {{ $store.getters.appVersion }} </span> </div>
        </v-footer>
    </div>
</template>

<style lang="scss">

.footer-height {
    height: calc(max(2%, 24px));
}
.feuchter-button{
    padding: 0 20px !important;
    margin-bottom: 15px !important;
}

.feuchter-bar {
    height: 100%;
    width: 100%;
    color: $font-color;
    background-image:
        linear-gradient(
            to right, 
            $feuchter-color1 0%,
            $feuchter-color1 calc((100% / 6) * 1),
            $feuchter-color2 calc((100% / 6) * 1),
            $feuchter-color2 calc((100% / 6) * 2),
            $feuchter-color3 calc((100% / 6) * 2),
            $feuchter-color3 calc((100% / 6) * 3),
            $feuchter-color4 calc((100% / 6) * 3),
            $feuchter-color4 calc((100% / 6) * 4),
            $feuchter-color5 calc((100% / 6) * 4),
            $feuchter-color5 calc((100% / 6) * 5),
            $feuchter-color6 calc((100% / 6) * 5)
      );
}
</style>
<script>
export default {
    methods: {
        reloadServiceWorker() {
            window.dispatchEvent( new Event('reloadServiceWorker') );
        },
    }
}
</script>
